/* eslint-disable no-template-curly-in-string */
import { ArrayLocale, BooleanLocale, DateLocale, MixedLocale, NumberLocale, ObjectLocale, StringLocale } from 'yup/lib/locale';
import printValue from 'yup/lib/util/printValue';
import { Message } from "yup/lib/types"

export const mixed: Required<MixedLocale> = {
  default: '${path} tidak valid',
  required: '${path} wajib diisi',
  oneOf: '${path} harus salah satu dari nilai berikut: ${values}',
  notOneOf: '${path} tidak boleh dari salah satu nilai berikut: ${values}',
  notType: ({ path, type, value, originalValue }) => {
    const isCast = originalValue != null && originalValue !== value;
    let msg =
      `${path} harus bertipe \`${type}\`, ` +
      `tapi nilai akhirnya: \`${printValue(value, true)}\`` +
      (isCast
        ? ` (diubah dari nilai \`${printValue(originalValue, true)}\`).`
        : '.');

    if (value === null) {
      msg += `\n Jika "null" dianggap nilai kosong pastikan schema menggunakan \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} harus terdefine',
};

export const string: Required<StringLocale & { ascii?: Message, emailOrPhone?: Message, zxcvbn?: Message }> = {
  length: '${path} harus tepat ${length} karakter',
  min: '${path} minimal ${min} karakter',
  max: '${path} maksimal ${max} karakter',
  matches: '${path} harus sesuai dengan regex: "${regex}"',
  email: '${path} harus berupa email yang valid',
  url: '${path} harus berupa URL yang valid',
  uuid: '${path} harus berupa UUID yang valid',
  trim: '${path} harus berupa karakter tanpa spasi di akhir',
  lowercase: '${path} harus huruf kecil',
  uppercase: '${path} harus huruf besar',

  ascii: '${path} mengandung karakter yang tidak valid',
  emailOrPhone: '${path} harus berupa data yang valid',
  zxcvbn: '${path} tidak cukup kuat.',
};

export const number: Required<NumberLocale> = {
  min: '${path} harus lebih dari atau sama dengan ${min}',
  max: '${path} harus kurang dari atau sama dengan ${max}',
  lessThan: '${path} harus kurang dari ${less}',
  moreThan: '${path} harus lebih dari ${more}',
  positive: '${path} harus angka positif',
  negative: '${path} harus angka negatif',
  integer: '${path} harus berupa bilangan bulat',
};

export const date: Required<DateLocale> = {
  min: '${path} harus setelah ${min}',
  max: '${path} harus sebelum ${max}',
};

export const boolean: BooleanLocale = {
  isValue: '${path} harus ${value}',
};

export const object: Required<ObjectLocale> = {
  noUnknown: '${path} mempunyai key yang belum dispesifikasi: ${unknown}',
};

export const array: Required<ArrayLocale & { unique?: Message }> = {
  min: '${path} harus memiliki minimal ${min} item',
  max: '${path} harus kurang dari atau sama dengan ${max} item',
  length: '${path} harus memiliki ${length} item',

  unique: '${path} sudah ada'
};

export default Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
});
